import {Box} from '@customink/pigment-react';
import {useMobileBreakpoint} from '@customink/pigment-react/lib/utils/useBreakpoint';
import {useFlagVariation} from '@customink/signalmizely-react';
import PropTypes from 'prop-types';
import React from 'react';
import {MOBILE_COLOR_SWATCHES_TEST_KEY} from 'constants/optimizelyFeatureFlagKeys';
import ProductColorSwatchesSkeleton from './ProductColorSwatchesSkeleton';
import ProductScrollableColorSwatchesContainer from './ProductScrollableColorSwatchesContainer';

export default function ProductColorsContainer({children, totalColorCount}) {
  const isMobile = useMobileBreakpoint();
  const {isError, isLoading, variation} = useFlagVariation(
    MOBILE_COLOR_SWATCHES_TEST_KEY
  );

  if (isLoading && isMobile) {
    return <ProductColorSwatchesSkeleton />;
  }

  if (variation === 'test' && isMobile && !isError) {
    return (
      <ProductScrollableColorSwatchesContainer
        totalColorCount={totalColorCount}>
        {children}
      </ProductScrollableColorSwatchesContainer>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        margin: '0 -0.25rem',
        paddingTop: {md: '0.5rem', sm: 0}
      }}>
      {children}
    </Box>
  );
}

ProductColorsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  totalColorCount: PropTypes.number.isRequired
};
